import { FC, JSX, useEffect, useState } from "react";
import { Container, Heading } from "@radix-ui/themes";
import JobInputForm from "@/features/jobs/components/manage/JobInputForm";
import { useAddJob } from "@/features/jobs/hooks/useAddJob";
import { Job } from "@/models/Job.model";
import { timestamp } from "@/api/firebase/firebase.config";
import slugify from "react-slugify";

const JobsCreatePage: FC = (): JSX.Element => {
  const [values, setValues] = useState<Job>({
    slug: "",
    status: "published",
    created_at: timestamp.now(),
    created_by: "",
    position: "",
    brand: "",
    event: "",
    event_dates: {
      start: timestamp.now(),
      end: timestamp.now(),
    },
    application_deadline: timestamp.now(),
    compensation: "",
    descriptions: {
      role: "",
      event: "",
      responsibilities: "",
      qualifications: "",
      offer: "",
    },
  } as Job);

  useEffect(() => {
    if (values.position) {
      setValues((prev: Job) => ({
        ...prev,
        slug: slugify(values.position),
      }));
    }
  }, [values.position]);

  const { addJobListing, loading, error } = useAddJob();

  return (
    <>
      <Container px={{ initial: "4", lg: "0" }}>
        <Heading size="4" mb="3">
          Create a Job
        </Heading>
        <JobInputForm
          loading={loading}
          error={error}
          handleSubmit={addJobListing}
          values={values}
          setValues={setValues}
        />
      </Container>
    </>
  );
};

export default JobsCreatePage;
